<template>
    <section>
        <div class="md:hidden">
            <div class="text-xl text-center">
                Acompanhe seus atendimentos
            </div>
        </div>
        <div class="mt-3 text-center text-purple-900 rounded-lg md:hidden justify-items-center place-items-center box-order-detail-button">
            <button
            id="btnCustomerTicketUrl"
            type="button"
            :disabled="loading"
            @click="getMyTicketUrl()"
            class="font-semibold border-purple-900 rounded-lg border-1 h-9 w-72 focus:outline-none focus:ring-0"
            >
                Meus atendimentos
            </button>
        </div>
        <div class="m-3 text-2xl text-center md:hidden">
            Meus Pedidos
        </div>
        <div class="grid grid-cols-2 gap-1 text-2xl font-black text-center text-gray-400 md:text-left md:grid-cols-12 ">
                <button
                    id="btnOpenStatusOpened"
                    type="button"
                    :disabled="loading"
                    :class="btnOpenStatus"
                    @click="changeStatusOrder('opened')"
                >
                    Abertos
                </button>
                <button
                    id="btnOpenStatusClosed"
                    type="button"
                    :disabled="loading"
                    :class="btnCloseStatus"
                    @click="changeStatusOrder('closed')"
                >
                    Fechados
                </button>
        </div>
        <spinner :loading="loading"/>

        <div v-if="error != null">
            <div class="mt-5">
                <h4 v-if="error.open" class="text-center text-yellow-500">
                    {{error.open}}
                    <span class="cursor-pointer text-purple-mobly" :disabled="loading" @click="changeStatusOrder('closed')" v-html="'Veja seus pedidos fechados!'"></span>
                </h4>
                <h4 v-if="error && !error.open" class="text-center" v-html="error"></h4>
            </div>
        </div>
        <div class="mt-8 md:grid md:grid-cols-2 md:gap-7">
            <div
                v-for="(item, index) in list"
                :key="index"
                class="mt-8 shadow-md rounded-xl md:mt-0"
            >
                <order-box :itemList="item"></order-box>
            </div>
        </div>

        <Pagination />

    </section>

</template>

<script>
import OrderBox from './Box'
import namespace from '../../vuex/namespace'
import { mapState, mapGetters, mapActions } from 'vuex'
import Spinner from '../Spinner/Spinner'
import Pagination from '../Pagination/Pagination'

export default {
  name: 'OrdersList',
  data: function () {
    return {
      page: 1,
      debug: false
    }
  },
  computed: {
    ...mapState(namespace.ORDERS, [
      'list',
      'error',
      'loading',
      'status'
    ]),
    ...mapGetters(namespace.ORDERS, [
      'getPage'
    ]),
    ...mapState(namespace.ROUTE, [
      'params'
    ]),
    btnOpenStatus: function () {
      if (this.status === 'opened') {
        return 'text-purple-900 no-underline md:underline focus:outline-none focus:ring-0 border-b-2 md:border-b-0 border-gray-500 hover:border-purple-900 hover:text-purple-900 font-semibold'
      }
      return 'no-underline md:underline focus:outline-none focus:ring-0 hover:opacity-70 border-b-2 md:border-b-0 border-gray-500 hover:border-purple-900'
    },
    btnCloseStatus: function () {
      if (this.status === 'closed') {
        return 'text-purple-900 no-underline md:underline focus:outline-none focus:ring-0 border-b-2 md:border-b-0 border-gray-500 hover:border-purple-900 hover:text-purple-900 font-semibold'
      }
      return 'no-underline md:underline focus:outline-none focus:ring-0 hover:opacity-70 border-b-2 md:border-b-0 border-gray-500 hover:border-purple-900'
    }
  },
  components: {
    OrderBox,
    Spinner,
    Pagination
  },
  mounted () {
    this.changeStatus(this.$route.query.filter)
    this.setPage(this.$route.query.page)
  },
  methods: {
    ...mapActions(namespace.ORDERS, [
      'loadOrders',
      'changeStatusOrder',
      'setPage',
      'changeStatus'
    ]),
    getMyTicketUrl () {
      window.open(`${process.env.VUE_APP_CS_EXTERNAL_URL}/redirect-my-tickets`, '_blank')
    }
  }
}
</script>
